module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pamela Ellgen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pamela Ellgen is the author of more than twenty cookbooks, including the best-selling "), _c('I', [_vm._v("The 5-Ingredient College Cookbook")]), _vm._v(", "), _c('I', [_vm._v("The Gluten-Free Cookbook for Families")]), _vm._v(", and "), _c('I', [_vm._v("The Big Dairy Free Cookbook")]), _vm._v(". Her work has been featured in "), _c('I', [_vm._v("Outside Magazine")]), _vm._v(", "), _c('I', [_vm._v("TODAY Food")]), _vm._v(", "), _c('I', [_vm._v("Huffington Post")]), _vm._v(", "), _c('I', [_vm._v("Darling Magazine, ")]), _vm._v("and "), _c('I', [_vm._v("The Portland Tribune.")]), _vm._v(" When she's not in the kitchen, she's surfing with her two boys off the coast of San Diego. You can find her on Instagram "), _c('a', {
    attrs: {
      "id": "m_-281890990058116951plusReplyChip-0"
    }
  }, [_vm._v("@surfgirleats.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ESWfyA/tc-custom/9781612436524.jpg?1705040360455",
      "alt": "This image is the cover for the book Cast Iron Paleo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cast Iron Paleo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("PALEO COOKING HAS NEVER BEEN EASIER THAN WITH THIS COLLECTION OF QUICK CAST IRON SKILLET RECIPES."), _c('br'), _c('br'), _vm._v(" Your healthy Paleo lifestyle is about to get easier and so much more delicious thanks to one pan and one book, "), _c('i', [_vm._v("Cast Iron Paleo")]), _vm._v(". On the stovetop or in the oven, your cast iron skillet brings out the flavors of pastured meats, fresh vegetables, healthy fats, and the savory spices you’ll find in these recipes, including:"), _c('br'), _c('br'), _vm._v(" •Maple-Glazed Pork Chops"), _c('br'), _vm._v(" •Sizzling Portobello Fajitas"), _c('br'), _vm._v(" •Bacon-Wrapped Filet Mignon with Broccolini"), _c('br'), _vm._v(" •Eggplant Involtini"), _c('br'), _vm._v(" •Mussels in Thai Coconut Broth"), _c('br'), _vm._v(" •Sage Pork Belly with Greens"), _c('br'), _vm._v(" •Honey Mustard Rosemary"), _c('br'), _vm._v(" •Chicken Thighs"), _c('br'), _vm._v(" •Plus breakfasts, desserts, and more! ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0